import React, {useEffect, useState} from 'react';
import {Button, Col, Container, Row} from 'react-bootstrap';
import {Glyphicon} from "../../Common/GlyphIcon";
import {service as ProgramService} from "../../../Services/ProgramService";

import {useMakePageRequest} from "../../../Hooks/RequestHooks";
import {useClassNames} from "../../../Hooks/StyleHooks";
import {usePermission} from "../../../Hooks/PermissionHooks";
import {useChangeContext} from "../../../Hooks/RouteHooks";

import {StreamBankPageHeader} from "../../Common/StreamBankPageHeader";
import {ProgramsTable} from "./Table";

export const ProgramsIndexPage = props => {
    const classNames = useClassNames('sb-programs-index-page');
    const permission = usePermission()
    const changeContext = useChangeContext();
    const makePageRequest = useMakePageRequest();

    const [programs, setPrograms] = useState(null);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        makePageRequest(
            () => ProgramService.GetPrograms(),
            (x) => {
                let rootPrograms = x.result.filter((x) => x.parentProgramId === null );
                setPrograms(rootPrograms);
            },
        );
    };

    return <Container className={classNames}>
        <div>
            <StreamBankPageHeader
                Title={"Programs"}
            />

            <Row>
                <Col xs={12} md={6}><h2>Programs</h2></Col>
                <Col xs={12} md={6}>
                    {
                        permission('create_program') ?
                            <Button variant="link" className="float-right h3" onClick={() => changeContext({parentProgram: "new"})}>
                                <Glyphicon glyph="plus-sign">Add Program</Glyphicon>
                            </Button>:
                            null
                    }
                </Col>
            </Row>
            <div>
                <hr />
            </div>
            <Row>
                <Col xs={12}>
                    <ProgramsTable
                        Data={programs}
                    />
                </Col>
            </Row>
        </div>
    </Container>;
};


